<template>
  <vue-js-modal
    v-if="compareNode"
    :key="reload"
    id="agCompareNodeModal"
    class="agModal"
    name="agCompareNodeModal"
    draggable=".card-header"
    width="75%"
    height="85%"
    :shiftX=".5"
    :shiftY=".25"
    :resizable="true"
    :clickToClose="false">
    <b-card>
      <template #header>
        <h4 v-if="disableUI || isLoading" class="agModal-title">View Compare Node {{compareNode.shortname}}</h4>
        <h4 v-else class="agModal-title">Edit Compare Node {{compareNode.shortname}}</h4>
      </template>

      <div class="agInputGroup agInputGroupCentered">
        <label>Source:</label>
        <b-input
          type="text"
          :value="srcStr"
          autocomplete="false"
          disabled>
        </b-input>
      </div>
      <b-input-group size="md" prepend="Name">
        <b-input
          type="text"
          v-model="compareNode.name"
          autocomplete="false"
          :disabled="disableUI || isLoading">
        </b-input>
      </b-input-group>
      <b-input-group size="md" prepend="Description">
        <b-input
          type="text"
          v-model="compareNode.description"
          autocomplete="false"
          :disabled="disableUI || isLoading">
        </b-input>
      </b-input-group>
      <hr/>
        <input
          type="checkbox"
          v-model="compareNode.hasBreakpoint"
          :disabled="disableUI || isLoading"/>
        <label>Has Breakpoint</label>

      <div class="agInputGroup agInputGroupCentered">
        <label>Input A</label>
        <b-input type="text" :value="inputAName" class="agInput agMediumInput" disabled></b-input>
        <b-button class="agImageButton" @click="setInputAButton_click"><fa icon="pen"/></b-button>
      </div>
      <div class="agInputGroup agInputGroupCentered">
        <label>Input B</label>
        <b-input type="text" :value="inputBName" class="agInput agMediumInput" disabled></b-input>
        <b-button class="agImageButton" @click="setInputBButton_click"><fa icon="pen"/></b-button>
      </div>
      <hr/>
      <div class="agInputGroup agInputGroupCentered">
        <label>Comparisons:</label>
        <b-table
          :key="'comps-' + reloadComps"
          id="agCompareNodeModal-compTable"
          :fields="compHeaders"
          :items="comps"
          :thead-class="{ theadHidden: isLoadingComps }"
          borderless
          outlined
          small>
          <template #head(equals)>
            =
          </template>
          <template #cell(key_field)="data">
            <input class="agCompareNodeModal-keyFieldCheckbox" type="checkbox" v-model="data.item.isKeyField" :disabled="disableUI || (!data.item.inputAField && !data.item.inputBField)"/>
          </template>
          <template #cell(input_a)="data">
            <b-form-select
              v-model="data.item.inputAField"
              :options="inputAFields"
              class="agLargeInput"
              :disabled="!compareNode.inputA"
              @change="compField_change(data.item)">
            </b-form-select>
          </template>
          <template #cell(equals)>
            <div class="agCompareNodeModal-compEquals">=</div>
          </template>
          <template #cell(input_b)="data">
            <b-form-select
              v-model="data.item.inputBField"
              :options="inputBFields"
              class="agLargeInput"
              :disabled="!compareNode.inputB"
              @change="compField_change(data.item)">
            </b-form-select>
          </template>
        </b-table>
        <b-spinner
          v-if="isLoadingComps"
          id="agCompareNodeModal-loadingCompsSpinner">
        </b-spinner>
      </div>
      <hr/>
      <div id="agCompareNodeModal-dests" class="agInputGroup">
        <div v-if="dest_equal" class="agInputGroup">
          <input
            type="checkbox"
            v-model="dest_equal.selected"
            :disabled="disableUI || isLoading"/>  
          <label>Destination A:</label>
          <b-input 
            v-model="dest_equal.alias"
            class="agInput agMediumInput"
            placeholder="label A"
            maxlength=25>
          </b-input>   
          <b-input type="text" :value="destName_equal" class="agInput agExtraSmallInput" disabled></b-input>
          <label class="agInputGroup-append">Equal records in both inputs</label>
        </div>
        <div v-if="dest_diff" class="agInputGroup">
          <input
            type="checkbox"
            v-model="dest_diff.selected"
            :disabled="disableUI || isLoading"/>  
          <label>Destination B:</label>
          <b-input 
            v-model="dest_diff.alias"
            class="agInput agMediumInput"
            placeholder="label B"
            maxlength=25>
          </b-input>   
          <b-input type="text" :value="destName_diff" class="agInput agExtraSmallInput" disabled></b-input>
          <label class="agInputGroup-append">Records in both inputs but with differences</label>
        </div>
        <div v-if="dest_aNotB" class="agInputGroup">
          <input
            type="checkbox"
            v-model="dest_aNotB.selected"
            :disabled="disableUI || isLoading"/>  
          <label>Destination C:</label>
          <b-input 
            v-model="dest_aNotB.alias"
            class="agInput agMediumInput"
            placeholder="label C"
            maxlength=25>
          </b-input>   
          <b-input type="text" :value="destName_aNotB" class="agInput agExtraSmallInput" disabled></b-input>
          <label class="agInputGroup-append">Records in input A, not in input B</label>
        </div>
        <div v-if="dest_bNotA" class="agInputGroup">
          <input
            type="checkbox"
            v-model="dest_bNotA.selected"
            :disabled="disableUI || isLoading"/>  
          <label>Destination D:</label>
          <b-input 
            v-model="dest_bNotA.alias"
            class="agInput agMediumInput"
            placeholder="label D"
            maxlength=25>
          </b-input>   
          <b-input type="text" :value="destName_bNotA" class="agInput agExtraSmallInput" disabled></b-input>
          <label class="agInputGroup-append">Records in input B, not in input A</label>
        </div>
      </div>
      

      <template #footer>
        <b-spinner v-if="isLoading" class="agModal-loadingSpinner"></b-spinner>
        <div v-else-if="modalMessage">
          <label class="agModal-message" :class="modalMessageClass">{{modalMessage}}</label>
        </div>

        <b-button class="agModal-buttonLeft" @click="cancelButton_click">Cancel</b-button>
        <b-button
          class="agModal-buttonRight"
          variant="primary"
          :disabled="disableUI || isLoading"
          @click="saveButton_click">
          Save
        </b-button>
        <b-button
          class="agModal-buttonRight"
          variant="danger"
          :disabled="disableUI || isLoading"
          @click="deleteButton_click">
          Delete
        </b-button>
      </template>
    </b-card>

    <!-- delete modal -->
    <b-modal
      class="agModal"
      ref="deleteModal"
      centered
      no-close-on-esc
      no-close-on-backdrop
      @keyup.enter.native="deleteButton_click">
      <template slot="modal-header">
        <h4 class="agModal-title danger">Delete Compare Node</h4>
      </template>
      Are you sure you want to delete compare node
      <i>{{ name }}</i>?
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button class="agModal-buttonLeft" @click="cancel">
          Cancel
        </b-button>
        <b-button
          class="agModal-buttonRight"
          variant="danger"
          @click="confirmDeleteButton_click">
          Delete
        </b-button>
      </template>
    </b-modal>

    <!-- Child Input Modal -->
    <ag-childInput-modal
      ref="inputModal"
      :workflow="workflow"
      :disableUI="disableUI || isLoading"
      @updatedNode="inputModal_updatedNode"
      @deletedNode="inputModal_deletedNode">

    </ag-childInput-modal>

  </vue-js-modal>
</template>

<script>
// components
import ChildInputModal from "comp/nodes/ChildInputModal";
import InputSelect from "comp/ui/InputSelect";

// modules
import Vue from "vue";
import Util from "src/util/util";

export default {
  name: "ag-compareNode-modal",
  components: {
    "ag-childInput-modal": ChildInputModal,
    "ag-input-select": InputSelect
  },
  props: {
    node: Object,
    workflow: Object,
    disableUI: Boolean
  },
  data() {
    return {
      compareNode: null,
      reload: 0,
      reloadComps: 0,
      isLoading: false,
      isLoadingComps: false,
      modalMessage: "",
      modalMessageClass: "",
      inputAName: "",
      inputBName: "",
      comps: [],
      compHeaders: ["key_field", "input_a", "equals", "input_b"],
      dest_equal: null,
      dest_diff: null,
      dest_aNotB: null,
      dest_bNotA: null
    }
  },
  computed: {

    name() {
      if (this.compareNode.name)
        return this.compareNode.name;
      
      return this.compareNode.shortname;
    },

    srcStr() {
      if (!this.compareNode.src || this.compareNode.src.length == 0) return "";

      var srcStr = "";
      for (var i = 0; i < this.compareNode.src.length; i++) {
        var src = this.compareNode.src[i];
        srcStr += src.shortname + ", ";
      }
      srcStr = srcStr.substring(0, srcStr.length - 2); // remove the last ,
      return srcStr;
    },

    destName_equal() {
      if (this.compareNode.dest_equal) 
        return this.compareNode.dest_equal.shortname;
      return "";
    },

    destName_diff() {
      if (this.compareNode.dest_diff) 
        return this.compareNode.dest_diff.shortname;
      return "";
    },

    destName_aNotB() {
      if (this.compareNode.dest_aNotB) 
        return this.compareNode.dest_aNotB.shortname;
      return "";
    },

    destName_bNotA() {
      if (this.compareNode.dest_bNotA) 
        return this.compareNode.dest_bNotA.shortname;
      return "";
    },

    inputAFields() {
      if(!this.compareNode.inputA)
        return [];
      return ["-- None --"].concat(this.compareNode.inputA.fields);
    },

    inputBFields() {
      if(!this.compareNode.inputB)
        return [];

        return ["-- None --"].concat(this.compareNode.inputB.fields);
    },
  },

  watch: {
  },

  methods: {

    // UI Events

    cancelButton_click() {
      this.hide();
    },

    async saveButton_click(e, cancelHide) {
      this.modalMessage = "";

      // build compareNode.comps w/ comps that actually have values
      var validComps = [];
      for (let i = 0; i < this.comps.length; i++) {
        let comp = this.comps[i];
        if (comp.inputAField || comp.inputBField)
          validComps.push(comp);
      }
      this.compareNode.comps = validComps;

      // save only selected dests
      // dest_equal
      if(this.dest_equal.selected) {
        this.compareNode.dest_equal = JSON.parse(JSON.stringify(this.dest_equal));
        delete this.compareNode.dest_equal["selected"];
      }
      else
        this.compareNode.dest_equal = null;
      // dest_diff
      if(this.dest_diff.selected) {
        this.compareNode.dest_diff = JSON.parse(JSON.stringify(this.dest_diff));
        delete this.compareNode.dest_diff["selected"];
      }
      else
        this.compareNode.dest_diff = null;
      // dest_aNotB
      if(this.dest_aNotB.selected) {
        this.compareNode.dest_aNotB = JSON.parse(JSON.stringify(this.dest_aNotB));
        delete this.compareNode.dest_aNotB["selected"];
      }
      else
        this.compareNode.dest_aNotB = null;
      // dest_bNotA
      if(this.dest_bNotA.selected) {
        this.compareNode.dest_bNotA = JSON.parse(JSON.stringify(this.dest_bNotA));
        delete this.compareNode.dest_bNotA["selected"];
      }
      else
        this.compareNode.dest_bNotA = null;

      var node = {
        object: this.compareNode,
        type: "compareNode"
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/updateNode", {
        node: node
      });
      this.isLoading = false;
      if (result.data.success) {
        var updated = {
          type: "compareNode",
          object: result.data.node
        };

        // reapply full inputs, result only has inputs' ids
        updated.object.inputA = this.compareNode.inputA; 
        updated.object.inputB = this.compareNode.inputB;
        this.setCompareNode(); // resets dests w/ default values

        if(!cancelHide) {
          this.hide();
          this.$emit("updatedNode", updated);
        }
      } else {
        this.modalMessage = result.data.error;
        this.modalMessageClass = "agModal-errorMessage";
      }
    },

    deleteButton_click() {
      this.$refs.deleteModal.show();
    },

    async confirmDeleteButton_click() {
      this.$refs.deleteModal.hide();
      var node = {
        object: this.compareNode,
        type: "compareNode"
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/deleteNode", {
        node: node
      });
      this.$emit("deletedNode", node);
      this.isLoading = false;
      this.hide();
    },

    setInputAButton_click() {
      if(!this.compareNode.inputA) {
        this.compareNode.inputA = {
          shortname: "I-A",
          workflow: null, // keep wf null so it doesn't show in editor
          connection: null,
          fields: [],
          wClause: "",
          queryParams: null,
          layer: null,
          fields: [],
          includeGeometry: true,
          geometryType: ""
        }
      }
      this.$refs.inputModal.show(this.compareNode.inputA);
    },

    setInputBButton_click() {
      if(!this.compareNode.inputB) {
        this.compareNode.inputB = {
          shortname: "I-B",
          workflow: null, // keep wf null so it doesn't show in editor
          connection: null,
          fields: [],
          wClause: "",
          queryParams: null,
          layer: null,
          fields: [],
          includeGeometry: true,
          geometryType: ""
        }
      }
      this.$refs.inputModal.show(this.compareNode.inputB);
    },

    compField_change(comp) {
      if(comp.inputAField == "-- None --")
        comp.inputAField = null;
      if(comp.inputBField == "-- None --")
        comp.inputBField = null;

      this.checkCompRows();
    },

    // emitted events

    inputModal_updatedNode(input) {
      if(input.shortname == "I-A") {
        this.compareNode.inputA = input;
        this.inputAName = this.compareNode.inputA.name || this.compareNode.inputA.shortname;
      }
      else {
        this.compareNode.inputB = input;
        this.inputBName = this.compareNode.inputB.name || this.compareNode.inputB.shortname;
      }

      this.saveButton_click(null, true);
    },

    inputModal_deletedNode(input) {
      if(input.shortname == "I-A") {
        this.compareNode.inputA = null;
        this.inputAName = "";
      }
      else {
        this.compareNode.inputB = null;
        this.inputBName = "";
      }

      this.saveButton_click(null, true);
    },

   
    // other

    async show() {
      await this.setCompareNode();
      await Vue.nextTick();
      await this.reset();
      this.$modal.show("agCompareNodeModal");
    },

    hide() {
      this.$modal.hide("agCompareNodeModal");
    },

    async reset() {
      this.modalMessage = "";
      this.modalMessageClass = "";
      this.errorField = "";
      this.inputAName = "";
      this.inputBName = "";
  
      if(this.compareNode.inputA)
        this.inputAName = this.compareNode.inputA.name || this.compareNode.inputA.shortname;
      if(this.compareNode.inputB)
        this.inputBName = this.compareNode.inputB.name || this.compareNode.inputB.shortname;

      // init dests w/ selected attr
      // dest_equal
      if(this.compareNode.dest_equal) {
        this.dest_equal = JSON.parse(JSON.stringify(this.compareNode.dest_equal));
        this.dest_equal.selected = true;
      }
      else
        this.dest_equal = {selected: false, alias: "", shortname: null, _id: null};
      // dest_diff
      if(this.compareNode.dest_diff) {
        this.dest_diff = JSON.parse(JSON.stringify(this.compareNode.dest_diff));
        this.dest_diff.selected = true;
      }
      else
        this.dest_diff = {selected: false, alias: "", shortname: null, _id: null};
      // dest_aNotB
      if(this.compareNode.dest_aNotB) {
        this.dest_aNotB = JSON.parse(JSON.stringify(this.compareNode.dest_aNotB));
        this.dest_aNotB.selected = true;
      }
      else
        this.dest_aNotB = {selected: false, alias: "", shortname: null, _id: null};
      // dest_bNotA
      if(this.compareNode.dest_bNotA) {
        this.dest_bNotA = JSON.parse(JSON.stringify(this.compareNode.dest_bNotA));
        this.dest_bNotA.selected = true;
      }
      else
        this.dest_bNotA = {selected: false, alias: "", shortname: null, _id: null};

      this.setComps();
    },

    async setCompareNode() {
      if (this.node && this.node.type == "compareNode")
        this.compareNode = this.workflow.compareNodes.find(object => object._id == this.node.object._id);
      else {
        this.compareNode = null;
        return;
      }
    },

    setComps() {
      this.comps = this.compareNode.comps;
      if(!this.comps)
        this.comps = [];
      this.checkCompRows();
    },

    checkCompRows() {
      let rowsToRemove = [];
      for(let i = 0; i < this.comps.length; i++) {
        let comp = this.comps[i];
        if(this.isCompEmpty(comp))
          rowsToRemove.push(comp);
      }
      this.comps = this.comps.filter(a => rowsToRemove.indexOf(a) < 0);

      // add empty row to bottom
      var newComp = {
        isKeyField: false,
        inputAField: null,
        inputBField: null
      };
      this.comps.push(newComp);
    },

    isCompEmpty(comp) {
      if(!comp.inputAField && !comp.inputBField)
        return true;
      return false;
    },
  }

};

</script>

<style scoped lang="css">

#agCompareNodeModal-compTable {
  max-width: 1000px;
  margin: auto;
}

.agCompareNodeModal-keyFieldCheckbox {
  position: relative;
  top: 10px;
}

.agCompareNodeModal-compEquals {
  position: relative;
  top: 7.5px;
}

#agCompareNodeModal-dests  {
  padding-left: 250px;
}


</style>



// WEBPACK FOOTER //
// src/components/nodes/CompareNodeModal.vue